import { render, staticRenderFns } from "./ListFormComponent.vue?vue&type=template&id=15ce2c80&scoped=true&"
import script from "./ListFormComponent.vue?vue&type=script&lang=js&"
export * from "./ListFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./ListFormComponent.vue?vue&type=style&index=0&id=15ce2c80&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ce2c80",
  null
  
)

export default component.exports